import React, { Component } from 'react';
import * as d3 from 'd3';


import VillagerAvatar from '../components/VillagerAvatar';
import LeafSvgUrl from '../images/leaf.svg';
import StarSvgUrl from '../images/star.svg';

import ChartSpecs from '../data/chart_specs';
import Dialogue from '../components/Dialogue';

const colorWheelObj = ChartSpecs.chartspecs.colorWheelObjBoolean
var colorWheelArray = Object.keys(colorWheelObj);
var colorRange = Object.values(colorWheelObj);
var margin = ChartSpecs.chartspecs.margin;

class VillagerAmibo extends Component {
  constructor(props){
      super(props);
      this.allVillagers = this.props.villagers;
   }
  render() {
    let newVillagers = this.allVillagers.filter(v => v.Amiibo === "NO");

    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-gameplay">
        <h2 className="title">Villager amiibo</h2>
        <p className="paragraph">Most of the villagers in the game have an <a className="inline-tooltip" href="#" aria-label="Nintendo’s officially way of inviting new villagers to your island">Amiibo card</a> for sale. However, there are 8 villagers that are new to the New Horizons game and don't have Amiibos as of April 2021 when our analysis began.</p>
        {/*

        */}
        <ul className="new-villager-list">
        {newVillagers.map(villager => (
            <li className="new-villager" key={villager.id} >
              <VillagerAvatar villagers={newVillagers} villager={villager.name} ranking={villager.Average_Popularity_Ranking} />
            </li>
        ))}
        </ul>
        <p className="paragraph">Because they don’t have Amiibos, they are harder to collect; you have to randomly meet them in-game to invite them to your island until the relase of Amiibo series 5 in 2022.</p>
        <p className="paragraph haspointer">As it turns out, there’s a very strong relationship between a villager’s popularity and whether they have an Amiibo. <span id="acnh-icon-star" style={{ backgroundImage: `url(${StarSvgUrl})`}}></span> <b>6</b> out of <b>8</b> of the non-Amiibo villagers are in <a className="inline-tooltip mini" href="#" aria-label="Top 40 villagers">Tier 1</a> of villager popularity.</p>

        <Dialogue title="Summary" type="regular">
            <p className="paragraph">The villagers who don’t have Amiibos are significantly more popular, possibly because they are newer and harder to obtain.</p>
          </Dialogue>
      </div>
    )
  }
}

export default VillagerAmibo;
